module.exports = __webpack_public_path__ + "images/c46f1b6bdf1a68e8394b16c7a153b252-IMG_4686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_4686.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_4686.jpg
// module chunks = 0